import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="mt-28 pt-8 pb-8 px-6 md:px-10 border-t border-[color:var(--line)] md:hidden">
      <div className="flex flex-wrap items-baseline gap-x-5 gap-y-2">
        <span className="brand-mark">Alice Lisi</span>
        <span className="font-serif text-[13px] text-[color:var(--ink-mute)]">© 2026</span>
        <Link to="/projects" className="font-serif text-[13px] tlink-mute">Projects</Link>
        <Link to="/commercial" className="font-serif text-[13px] tlink-mute">Commercial</Link>
        <Link to="/films" className="font-serif text-[13px] tlink-mute">Films</Link>
        <Link to="/exhibitions" className="font-serif text-[13px] tlink-mute">Exhibitions</Link>
        <Link to="/shop" className="font-serif text-[13px] tlink-mute">Shop</Link>
        <Link to="/about" className="font-serif text-[13px] tlink-mute">Info</Link>
      </div>
    </footer>
  );
};

export default Footer;
